module.exports = __webpack_public_path__ + "images/digital-content-blue-4969d63d.svg";